// Entry point for the build script in package.json
import {} from 'jquery-ujs'

// Globally exposed libraries that the legacy-cjs depend upon
import { Turbo } from '@hotwired/turbo-rails'
window.Turbo = Turbo;

import '../src/javascripts/routes_import'

import _ from 'underscore'
window._ = _;

import dayjs from '../src/javascripts/dayjs_setup'
window.dayjs = dayjs;

// Import side-effects
import '../src/libs/bootstrap.min.js';

// Loaded using import maps as there's some strange issue when trying to use es modules
import '../vendor/datatables.min.js'

//= require tinymce-jquery (4.9.11)
import './tinymce-imports.js';

//= require js/select2.min
import 'select2';

//= require bootstrap-datetimepicker
// gem 'bootstrap3-datetimepicker-rails', '~> 4.17.37'
import "flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
window.monthSelectPlugin = monthSelectPlugin;
